import {
  getNonFeaturedJobs,
  getFeaturedJobs,
} from '../../../job_search/services/job_search.service';
import { GetJobsResponse } from '../../../job_search/types';

export const getExclusiveJobs = (
  orgName: string, isSignedIn: boolean, membership: string
): Promise<number> => {

  const queryParams = {
    organization_names: [orgName],
    job_types: ['exclusive jobs'],
  };

  return Promise
    .all([
      getNonFeaturedJobs(
        isSignedIn, queryParams, {field: 'updated_at', order: 'desc'}, 1, membership
      ),
      getFeaturedJobs(
        isSignedIn, queryParams, {field: 'updated_at', order: 'desc'}, 1, membership
      ),
    ])
    .then((responses: [GetJobsResponse, GetJobsResponse]) => {
      const [jobsResponse, featuredJobsResponse] = responses;
      return jobsResponse.total + featuredJobsResponse.total;
    })
    .catch((error) => Promise.reject(error));
};

export const getAllJobs = (
  orgName: string, isSignedIn: boolean, membership: string
): Promise<[GetJobsResponse, GetJobsResponse]> => {
  const queryParams = {
    organization_names: [orgName],
  };

  return Promise
    .all([
      getNonFeaturedJobs(
        isSignedIn, queryParams, {field: 'updated_at', order: 'desc'}, 1, membership
      ),
      getFeaturedJobs(
        isSignedIn, queryParams, {field: 'updated_at', order: 'desc'}, 1, membership
      ),
    ])
    .then((responses: [GetJobsResponse, GetJobsResponse]) => responses)
    .catch((error) => Promise.reject(error));
};
